import { combineReducers } from '@reduxjs/toolkit';

import { webapi } from '@/api/webapi.ts';
import { blotterSlice } from '@/store/blotter/slice.ts';
import { orderBulksSlice } from '@/store/bulkOrder/slice.ts';
import { bulkTradeSlice } from '@/store/bulkTrade/slice.ts';
import { cashSlice } from '@/store/cash/slice.ts';
import { espSlice } from '@/store/esp/slice.ts';
import { flexiForwardSlice } from '@/store/flexi-forward/slice.ts';
import { GrowlSlice } from '@/store/growl/slice.ts';
import { optionSlice } from '@/store/option/slice.ts';
import { ordersSlice } from '@/store/orders/slice.ts';
import { reduxFatalitySlice } from '@/store/reduxFatality/slice.ts';
import { streamingSlice } from '@/store/streaming/slice.ts';
import { swapSlice } from '@/store/swap/slice.ts';
import { tabsSlice } from '@/store/tabs/slice.ts';
import { targetAccumulatorSlice } from '@/store/targetAccumulator/slice.ts';
import { tilesSlice } from '@/store/tiles/slice.ts';
import { userPreferencesSlice } from '@/store/userPreferences/slice.ts';
import { workspaceSlice } from '@/store/workspace/slice.ts';

import { forwardAccumulatorSlice } from './forwardAccumulator/slice.js';

export const rootReducer = combineReducers({
  // API
  // [multipassApi.reducerPath]: multipassApi.reducer,
  [webapi.reducerPath]: webapi.reducer,

  // global
  [reduxFatalitySlice.reducerPath]: reduxFatalitySlice.reducer,

  // DATA
  [blotterSlice.reducerPath]: blotterSlice.reducer,
  [cashSlice.reducerPath]: cashSlice.reducer,
  [swapSlice.reducerPath]: swapSlice.reducer,
  [optionSlice.reducerPath]: optionSlice.reducer,
  [flexiForwardSlice.reducerPath]: flexiForwardSlice.reducer,
  [ordersSlice.reducerPath]: ordersSlice.reducer,
  [targetAccumulatorSlice.reducerPath]: targetAccumulatorSlice.reducer,
  [forwardAccumulatorSlice.reducerPath]: forwardAccumulatorSlice.reducer,

  [bulkTradeSlice.reducerPath]: bulkTradeSlice.reducer,
  [orderBulksSlice.reducerPath]: orderBulksSlice.reducer,

  [tabsSlice.reducerPath]: tabsSlice.reducer,

  [streamingSlice.reducerPath]: streamingSlice.reducer,
  [espSlice.reducerPath]: espSlice.reducer,
  [GrowlSlice.reducerPath]: GrowlSlice.reducer,

  //User Preferences
  [userPreferencesSlice.reducerPath]: userPreferencesSlice.reducer,

  // Layout
  [tilesSlice.reducerPath]: tilesSlice.reducer,
  [workspaceSlice.reducerPath]: workspaceSlice.reducer,
});
